/**
 * Authenticated fetch for private HuggingFace model files.
 *
 * Uses VITE_HF_TOKEN (baked into the build) to download ONNX models
 * from private HuggingFace repos. Returns an ArrayBuffer suitable
 * for ort.InferenceSession.create().
 */

const HF_TOKEN = import.meta.env.VITE_HF_TOKEN || '';

export async function fetchHFModel(url: string): Promise<ArrayBuffer> {
  const headers: Record<string, string> = {};
  if (HF_TOKEN) {
    headers['Authorization'] = `Bearer ${HF_TOKEN}`;
  }

  const resp = await fetch(url, { headers });
  if (!resp.ok) {
    throw new Error(
      `Failed to download model from ${url}: ${resp.status} ${resp.statusText}`,
    );
  }
  return resp.arrayBuffer();
}
